import { useKeychain } from '@treams/auth';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import Prelogin from 'authentication/Prelogin';
import AppAuthenticated from 'packages/kakapo-ui-application/pages/auth/AppAuthenticated';
import AppUnauthenticated from 'packages/kakapo-ui-application/pages/auth/AppUnauthenticated';
import { useWorkspace } from '../../../kakapo-ui-services/hooks/useWorkspace';

export function AppRoot() {
	const keychain = useKeychain();
	const workspace = useWorkspace();

	if (workspace.id === 'try' || location.pathname == '/try') {
		window.location.replace('https://treams.com/nl/try-treams');
		return <></>;
	} else if (workspace.id === 'login') {
		return <Prelogin />;
	}

	return (
		<HelmetProvider>
			<Helmet titleTemplate="%s - Treams" />
			{keychain.all().length > 0 ? <AppAuthenticated /> : <AppUnauthenticated />}
		</HelmetProvider>
	);
}

export default AppRoot;
